import {type ISystemGroup} from '../schema';
import {canManageSystemGroups} from './canManageSystemGroups';

/** can group be exported by current user */
export const canExportSystemGroup = (group?: ISystemGroup) =>
	!!group && canManageSystemGroups();
